export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20artistic%20aerial%20flat%20lay%20of%20diverse%20fashion%20accessories%20sneakers%20bags%20jewelry%20sunglasses%20and%20clothing%20elegantly%20arranged%20in%20circular%20organic%20pattern%20on%20warm%20cream%20textured%20surface%20soft%20diffused%20natural%20lighting%20editorial%20photography%20clean%20aesthetic%20warm%20beige%20palette%20harmonious%20decorative%20composition%20no%20text%20no%20logos%20luxury%20product%20display&width=1600&height=800&seq=cta-bg-cssbuy-v2-08&orientation=landscape"
          alt="CSSBuy Spreadsheet produtos"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[700px] mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-wider mb-5">
          ACESSE A CSSBUY SPREADSHEET
        </h2>

        <p className="text-sm md:text-base text-white/80 max-w-[500px] mx-auto leading-relaxed mb-10">
          Mais de 10.000 usuários já consultaram nosso CSSBuy Spreadsheet. 
          Acesse agora e descubra os produtos mais procurados.
        </p>

        {/* CTA Button */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 text-sm font-semibold bg-black/85 text-white rounded-full hover:bg-black transition-all whitespace-nowrap group"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 -ml-2">
            <i className="ri-shopping-bag-line text-white text-xs"></i>
          </span>
          COMPRAR AGORA
          <i className="ri-arrow-right-up-line text-white/70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}